module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/trigger-statements/trigger-statements.component.css
// module id = ./src/app/trigger-statements/trigger-statements.component.css
// module chunks = main